import {
  ActionType,
  createAction,
  createAsyncAction
} from 'typesafe-actions';
import {
  IAuthentication,
  IAuthenticationErrors,

  ILoginActionPayload,
  IResetPasswordActionPayload,
  IUpdatePasswordActionPayload,
} from './auth-redux.model';

import {
  AuthActionType
} from './auth-action-types';

export const AuthAction = {
  autoLogin: createAsyncAction(
    AuthActionType.AutoLogin,
    AuthActionType.LoginSuccess,
    AuthActionType.LoginFailure
  )<string, IAuthentication, Error>(),

  login: createAsyncAction(
    AuthActionType.Login,
    AuthActionType.LoginSuccess,
    AuthActionType.LoginFailure
  )<ILoginActionPayload, IAuthentication, Error>(),

  logout: createAction(AuthActionType.Logout)(),

  completeConsent: createAsyncAction(
    AuthActionType.CompleteConsent,
    AuthActionType.CompleteConsentSuccess,
    AuthActionType.CompleteConsentFailure
  )<string, IAuthentication, Error>(),

  resetPasswordLink: createAsyncAction(
    AuthActionType.ResetPasswordLink,
    AuthActionType.ResetPasswordLinkSuccess,
    AuthActionType.ResetPasswordLinkFailure
  )<IResetPasswordActionPayload, boolean, Error>(),

  resetPasswordTokenValidate: createAsyncAction(
    AuthActionType.ResetPasswordTokenValidate,
    AuthActionType.ResetPasswordTokenValidateSuccess,
    AuthActionType.ResetPasswordTokenValidateFailure
  )<IResetPasswordActionPayload, boolean, Error>(),

  resetPassword: createAsyncAction(
    AuthActionType.ResetPassword,
    AuthActionType.ResetPasswordSuccess,
    AuthActionType.ResetPasswordFailure
  )<IResetPasswordActionPayload, boolean, Error>(),

  updatePasword: createAsyncAction(
    AuthActionType.UpdatePassword,
    AuthActionType.UpdatePasswordSuccess,
    AuthActionType.UpdatePasswordFailure
  )<IUpdatePasswordActionPayload, boolean, Error>(),

  updateAuthErrors: createAction(AuthActionType.UpdateAuthErrors)<
    Partial<IAuthenticationErrors>
  >()
  ,

  updateMfa: createAsyncAction(
    AuthActionType.UpdateMFA,
    AuthActionType.UpdateMFASuccess,
    AuthActionType.UpdateMFAFailure
  )<{ enabled: boolean }, { enabled: boolean }, Error>()
};

export type UserActionLogin = ActionType<
  typeof AuthAction.login.request
>;

export type UserActionLoginUserSuccess = ActionType<
  typeof AuthAction.login.success
>;

export type UserActions = ActionType<typeof AuthAction>;
